import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setDisplayLoader } from 'redux/app/appSlice';
import {
  setRefcode,
  setReflink,
  setActiveReferralsLevel1,
  setActiveReferralsLevel2,
  setActiveReferralsLevel3,
  setWithdrawMethods,
  setWithdrawStatus,
  setServersStats,
  setServersRewards,
  setServersConversion,
  setClients,
  setNetwork,
  setPromocodes,
  setPromocodeDiscounts,
  setCreatePromocodeStatus,
  setDeletePromocodeStatus,
  setWithdrawMin,
  setWithdrawFee,
} from 'redux/partners/partnersSlice';
import RouteNames from 'router/routes';

import partnersService from 'services/partnersService';

const APP_URL = import.meta.env.VITE_APP_URL;

// Расшифровка партнерского кода - ПЕРЕДАЧА КЛИКА
const sendClick = (data) => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await partnersService.sendClick(data)
  } catch (e) {
    if (e.response?.status === 401) return
    Notify.failure(e.response?.data?.message || 'Request SendClick failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

// Получение данных пользователя по Партнерке
const getUserPartnershipData = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    const response = await partnersService.getUserPartnershipData()
    const {
      referral_code,
      level_1_referral_active_count,
      level_2_referral_active_count,
      level_3_referral_active_count,
      partnerMinWithdrawal,
      withdrawalFee
    } = response.data

    dispatch(setRefcode(referral_code || '...'))
    dispatch(setReflink(referral_code ? `${APP_URL}/${RouteNames.SIGNUP}/?ref=${referral_code}` : '...'))

    dispatch(setActiveReferralsLevel1(level_1_referral_active_count))
    dispatch(setActiveReferralsLevel2(level_2_referral_active_count))
    dispatch(setActiveReferralsLevel3(level_3_referral_active_count))

    dispatch(setWithdrawMin(partnerMinWithdrawal))
    dispatch(setWithdrawFee(withdrawalFee))
  } catch (e) {
    if (e.response?.status === 401) return
    Notify.failure(e.response?.data?.message || 'Request GetUserPartnershipData failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

// Получение списка платежных систем для вывода партнерских
const getWithdrawMethods = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    const response = await partnersService.getWithdrawMethods()
    const { data } = response

    dispatch(setWithdrawMethods(data))
  } catch (e) {
    if (e.response?.status === 401) return
    Notify.failure(e.response?.data?.message || 'Request GetWithdrawMethods failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

// Создание заявки на вывод партнерки
const withdrawReward = (data) => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await partnersService.withdrawReward(data)
    dispatch(setWithdrawStatus('success'))
  } catch (e) {
    if (e.response?.status === 409) {
      dispatch(setWithdrawStatus(e.response?.data?.message))
      return
    }

    dispatch(setWithdrawStatus('error'))

    Notify.failure(e.response?.data?.message || 'Request WithdrawReward failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const getStatisticsServers = (params) => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))

    const response = await partnersService.getStatisticsServers(params)
    const { rewardData, conversionData, ...rest } = response.data

    dispatch(setServersStats(rest))
    dispatch(setServersRewards(rewardData))
    dispatch(setServersConversion(conversionData))
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetStatisticsServers failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

// Партнёрская информация по уровням
const getStatisticsClients = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    const response = await partnersService.getStatisticsClients()
    const { data } = response
    const formattedData = data.map(({
      level, rewardForLevel, userCount, rewardCount, rewardSum
    }) => ({
      level,
      percent: rewardForLevel,
      clients: userCount,
      turnover: rewardCount,
      reward: rewardSum,
    }))

    dispatch(setClients(formattedData))
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetStatisticsClients failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const getNetwork = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    const response = await partnersService.getNetwork()
    const { data } = response
    dispatch(setNetwork(data))
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetNetwork failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const getPromocodes = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    const response = await partnersService.getPromocodes()
    const { data } = response.data
    dispatch(setPromocodes(data))
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetPromocodes failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

// Доступные скидки для создания и использования в промокоде
const getDiscounts = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    const response = await partnersService.getDiscounts()
    const { available_discounts } = response.data
    dispatch(setPromocodeDiscounts(available_discounts))
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetDiscounts failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const createPromocode = (data) => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await partnersService.createPromocode(data)
    dispatch(setCreatePromocodeStatus('success'))
    dispatch(getPromocodes())
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request CreatePromocode failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const deletePromocode = (id) => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await partnersService.deletePromocode(id)
    dispatch(setDeletePromocodeStatus('success'))
    dispatch(getPromocodes())
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request DeletePromocode failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

export default {
  sendClick,

  getUserPartnershipData,

  getWithdrawMethods,
  withdrawReward,

  getStatisticsServers,
  getStatisticsClients,

  getNetwork,

  getPromocodes,
  getDiscounts,
  createPromocode,
  deletePromocode,
}